<div >
  <canvas #canvases style="width: 100% !important;

        height: 200px !important;" ></canvas>
</div>
